<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="d-flex justify-space-between">
        <v-btn v-if="$store.state.is_initiated" @click="showCancel=true;" text><font-awesome-icon :icon="['far', 'fa-times']" class="mr-2"></font-awesome-icon>Cancel App</v-btn>
        <v-btn class="ml-auto" @click="showHelp=true;" text><font-awesome-icon :icon="['far', 'fa-comment']" class="mr-2"></font-awesome-icon>Need Help?</v-btn>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col cols="12" sm="4" class="pb-0">
        <div class="d-flex justify-space-around align-center">
          <v-img src="../assets/MEA_PrimaryFull_Navy.png" alt="MEA Logo" max-height="110px" max-width="278px"></v-img>
          <v-divider vertical></v-divider>
          <img src="../assets/msu-utsf.png" alt="Michigan State University Logo" class="px-2" height="95px" />
        </div>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col cols="12" class='text-center pt-1 pb-0'>
        <p class='text-h5 font-weight-light mb-0'>MSU UTSF Membership Application</p>
      </v-col>
    </v-row>
    <help-dialog :showDialog="showHelp" @close-dialog="showHelp=false"></help-dialog>
    <cancel-dialog :showDialog="showCancel" @close-dialog="showCancel = false"></cancel-dialog>
  </v-container>
</template>

<script>
import CancelDialog from './DialogComponents/CancelDialog.vue'
import HelpDialog from './DialogComponents/HelpDialog.vue'
  export default {
    name: 'AppHeader',
    props: {
      currentStep: Number
    },
    data:() => ({
      showHelp:false,
      showCancel:false
    }),
    components:{
      HelpDialog,
        CancelDialog
    }
  }
</script>

<style scoped>
.stepContainer{
  display:flex;
  justify-content:space-between;
}

</style>